import { useState } from "react";
import { Check, Copy } from "lucide-react";

export const AccountMetadata = ({ wallet, joinDate, network }) => {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(wallet);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {}
    };

    const date = new Date(`${joinDate}T00:00:00Z`).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });

    return (
        <div className="mt-6 grid grid-cols-1 divide-y divide-white/5 rounded-xl border border-white/5 bg-nx-alt sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-testid="account-metadata">
            <div className="px-5 py-4">
                <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">Wallet</p>
                <div className="mt-1.5 flex items-center gap-2">
                    <p className="truncate font-mono text-xs font-semibold text-nx-text" data-testid="metadata-wallet">
                        {wallet.slice(0, 21)}…
                    </p>
                    <button
                        type="button"
                        onClick={copy}
                        data-testid="metadata-copy"
                        aria-label={copied ? "Copied" : "Copy wallet address"}
                        className="shrink-0 text-nx-mute transition-colors duration-200 hover:text-nx-lime"
                    >
                        {copied ? <Check size={13} strokeWidth={2} className="text-nx-lime" /> : <Copy size={13} strokeWidth={1.5} />}
                    </button>
                </div>
            </div>
            <div className="px-5 py-4">
                <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">Join Date</p>
                <p className="mt-1.5 text-xs font-semibold text-nx-text tabular" data-testid="metadata-join-date">{date}</p>
            </div>
            <div className="px-5 py-4">
                <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-nx-mute">Network</p>
                <p className="mt-1.5 flex items-center gap-1.5 text-xs font-semibold text-nx-text">
                    <span className="h-1.5 w-1.5 rounded-full bg-nx-lime" aria-hidden="true" />
                    {network}
                </p>
            </div>
        </div>
    );
};
